import React from 'react';
const QRCode = require('qrcode.react');

export const MobilePhoneQRCode = ({url}) => {
  return (
    <div className={"container--mobile-phone-QR-code"}>
      <div className={"wrapper--QR-code-and-description"}>
        <p className={"header"}>The App</p>
        <p>Scan this QR code to access the app on your mobile phone.</p>
        <p>Control the output.</p>
        {
          url &&
          <QRCode
            size={90}
            value={url}
          />
        }
      </div>
    </div>
  );
};

export default MobilePhoneQRCode;